import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import { PrimaryCTA } from '../components/PrimaryCTA';
import { SecondaryCTA } from '../components/SecondaryCTA';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './AIHeroSection.module.css';

export function AIHeroSection() {
  return (
    <SectionWrapper
      background="navy"
      contentClassName={styles.content}
      data-testid="ai-section-hero"
    >
      <div className={styles.hero}>
        <Link className={styles.announce} to="/kai-coach">
          <span className={styles.announceBadge}>New</span>
          <span>Kai Coach: the AI coach that never writes the paper</span>
          <ArrowRight aria-hidden="true" className={styles.announceArrow} size={16} />
        </Link>
        <p className={styles.eyebrow}>INTRODUCING KAI</p>
        <h1 className={styles.title}>
          The AI that <span className={styles.highlight}>knows your course</span> and is built to
          teach, not to cheat.
        </h1>
        <p className={styles.body}>
          Course-aware. Privacy-first. Included in every Kudu course at no
          extra cost. And independently validated by UCLA to actually improve
          learning, especially for the students who need help the most.
        </p>
        <div className={styles.actions}>
          <PrimaryCTA
            className={styles.primary}
            href="/research"
            icon={<ArrowRight aria-hidden="true" size={16} />}
            label="Read the research"
          />
          <SecondaryCTA
            className={styles.secondary}
            href="/ai#how-kai-works"
            label="See how KAI works"
          />
        </div>
      </div>
    </SectionWrapper>
  );
}
